// Persistencia local del avance (handoff §5). Se guarda en cada cambio y
// permite "Continuar donde ibas". Nunca contiene datos personales: solo las
// respuestas anónimas al cuestionario.
import type { Answers } from '@gbcmc/survey-core';

export const STORAGE_KEY = 'gbcmc_eval_familias_2026_v1';

export type Phase = 'welcome' | 'survey' | 'done' | 'closed';

export interface PersistedState {
  answers: Answers;
  stepIndex: number;
  phase: Phase;
}

export function loadState(): PersistedState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as Partial<PersistedState>;
    if (!saved || typeof saved !== 'object' || !saved.answers) return null;
    return {
      answers: saved.answers,
      stepIndex: typeof saved.stepIndex === 'number' ? saved.stepIndex : 0,
      phase: saved.phase === 'done' ? 'done' : 'survey',
    };
  } catch {
    return null; // avance ilegible: se empieza de cero
  }
}

export function saveState(state: PersistedState): void {
  try {
    // 'closed' es un estado de runtime (depende del backend), no se persiste.
    const phase: Phase = state.phase === 'closed' ? 'survey' : state.phase;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...state, phase }));
  } catch {
    /* sin almacenamiento disponible: el flujo sigue funcionando en memoria */
  }
}

export function clearState(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
